"use client";
import React from "react";
import ProfileAvatar from "./ProfileAvatar";

const ProfileAvatarParent = () => {
  return (
    <div className="flex flex-row items-center justify-center mx-15">
      <ProfileAvatar />
    </div>
  );
};

export default ProfileAvatarParent;
